import { updateRunsheetUnassignedTableState } from '@/entities/gridTables/thunks/updateRunsheetUnassignedTableState'
import { runsheetsSelectors } from '@/entities/schedules'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { ordersSelectors } from '../ordersSelectors'
import { fetchRunsheetOrders } from './fetchRunsheetOrders'

type FetchOrdersByRunsheetPayload = {
  runsheetId: EntityId
  forceRefresh?: boolean
}

export const fetchUnassignedOrdersByRunsheet = createAsyncThunk<void, FetchOrdersByRunsheetPayload, ThunkApiContext>(
  'orders/fetchRunsheetOrdersByShift',
  async ({ runsheetId, forceRefresh }, { dispatch, getState }) => {
    const state = getState()
    const runsheet = runsheetsSelectors.selectById(state, runsheetId)

    if (runsheet.unassignedOrders) {
      const orderIds = runsheet.unassignedOrders
        .filter((orderId) => orderId !== undefined)
        .filter((orderId) => forceRefresh ? true : (orderId && !ordersSelectors.selectById(state, orderId)))

      if (orderIds.length > 0) {
        await dispatch(fetchRunsheetOrders({ orderIds }))
      }

      // Update the relevant unassigned table state after fetching the orders
      await dispatch(updateRunsheetUnassignedTableState({ runsheetId }))
    }
  },
)
